import { jsx as _jsx } from "react/jsx-runtime";
import Loadable from 'react-loadable';
import React from 'react';
import QuestionSingleImageSelect from '../components/question/SingleImageSelect';
import QuestionSingleImageSelectMultiSteps from '../components/question/SingleImageSelectMultiSteps';
import Loading from '../components/loading/Loading';
var NoLoading = function () { return _jsx("span", {}); };
// Component lookup table
// @ts-ignore
var componentMap = {
    Accordion: Loadable({
        loader: function () { return import('../components/accordion/AccordionContainer'); },
        loading: NoLoading,
    }),
    AccessibilityFeatures: Loadable({
        loader: function () { return import('../components/accessibility/AccessibilityFeatures'); },
        loading: NoLoading,
    }),
    AddToCalendarButton: Loadable({
        loader: function () { return import('../components/calendar/AddToCalendarButton'); },
        loading: NoLoading
    }),
    AffixContainer: Loadable({
        loader: function () { return import('../components/affix'); },
        loading: NoLoading,
    }),
    Alert: Loadable({
        loader: function () { return import('../components/alert/AlertContainer'); },
        loading: NoLoading,
    }),
    AnchorLink: Loadable({
        loader: function () { return import('../components/navigation/AnchorLink'); },
        loading: NoLoading,
    }),
    AnswerSummary: Loadable({
        loader: function () { return import('../components/question/answers/AnswerSummary'); },
        loading: NoLoading
    }),
    AppointmentUploadFile: Loadable({
        loader: function () { return import('../components/upload/AppointmentUploadFile'); },
        loading: NoLoading,
    }),
    AvatarLauncherContainer: Loadable({
        loader: function () { return import('../components/launcher/AvatarLauncherContainer'); },
        loading: NoLoading,
    }),
    AvatarTitle: Loadable({
        loader: function () { return import('../components/avatarTitle/AvatarTitle'); },
        loading: NoLoading,
    }),
    'Booking.LocationSelector': Loadable({
        loader: function () { return import('../components/booking/LocationSelector'); },
        loading: Loading,
    }),
    'Booking.BranchServiceSelector': Loadable({
        loader: function () { return import('../components/booking/BranchServiceSelector'); },
        loading: Loading,
    }),
    'Booking.AppointmentPickerForm': Loadable({
        loader: function () { return import('../components/booking/AppointmentPickerForm'); },
        loading: Loading,
    }),
    Button: Loadable({
        loader: function () { return import('../components/buttons/GenericButton'); },
        loading: NoLoading,
    }),
    'Buttons.Close': Loadable({
        loader: function () { return import('../components/buttons/CloseButton'); },
        loading: NoLoading,
    }),
    'Buttons.Inline': Loadable({
        loader: function () { return import('../components/buttons/InlineButton'); },
        loading: NoLoading,
    }),
    'Buttons.Link': Loadable({
        loader: function () { return import('../components/buttons/LinkButton'); },
        loading: NoLoading,
    }),
    'Buttons.Text': Loadable({
        loader: function () { return import('../components/buttons/TextButton'); },
        loading: NoLoading,
    }),
    'Buttons.Primary': Loadable({
        loader: function () { return import('../components/buttons/PrimaryButton'); },
        loading: NoLoading,
    }),
    'Buttons.Outline': Loadable({
        loader: function () { return import('../components/buttons/OutlineButton'); },
        loading: NoLoading,
    }),
    ButtonsLauncherContainer: Loadable({
        loader: function () { return import('../components/launcher/ButtonsLauncherContainer'); },
        loading: NoLoading,
    }),
    CallToAction: Loadable({
        loader: function () { return import('../components/callToAction/CallToActionContainer'); },
        loading: NoLoading,
    }),
    'Cards.List': Loadable({
        loader: function () { return import('../components/cards/ListCardComponent'); },
        loading: NoLoading,
    }),
    'Cards.Rating': Loadable({
        loader: function () { return import('../components/cards/RatingCardComponent'); },
        loading: NoLoading,
    }),
    'Cards.Text': Loadable({
        loader: function () { return import('../components/cards/TextCardComponent'); },
        loading: NoLoading,
    }),
    CarouselEquipment: Loadable({
        loader: function () { return import('../components/carousel/CarouselEquipment'); },
        loading: NoLoading,
    }),
    CarouselHints: Loadable({
        loader: function () { return import('../components/carousel/CarouselHints'); },
        loading: NoLoading,
    }),
    CarouselImageCenter: Loadable({
        loader: function () { return import('../components/carousel/CarouselImageCenter'); },
        loading: NoLoading,
    }),
    CarouselImageCenterFullScreen: Loadable({
        loader: function () { return import('../components/carousel/FullScreenGallery/FullScreenGallery'); },
        loading: NoLoading,
    }),
    CarouselRating: Loadable({
        loader: function () { return import('../components/carousel/CarouselRating'); },
        loading: NoLoading,
    }),
    Chip: Loadable({
        loader: function () { return import('../components/chip/ChipComponent'); },
        loading: NoLoading,
    }),
    Clickable: Loadable({
        loader: function () { return import('../components/clickable/Clickable'); },
        loading: NoLoading,
    }),
    ClickableBackdrop: Loadable({
        loader: function () { return import('../components/clickableBackdrop/ClickableBackdrop'); },
        loading: NoLoading,
    }),
    ClientAdvisor: Loadable({
        loader: function () { return import('../components/clientAdvisor/ClientAdvisor'); },
        loading: NoLoading,
    }),
    ClosableContainer: Loadable({
        loader: function () { return import('../components/collapsible/ClosableContainer'); },
        loading: NoLoading,
    }),
    Collapsible: Loadable({
        loader: function () { return import('../components/collapsible/CollapsibleComponent'); },
        loading: NoLoading,
    }),
    CounterOverTime: Loadable({
        loader: function () { return import('../components/counters/CounterOverTimeContainer'); },
        loading: NoLoading,
    }),
    'Data.InsertLocationData': Loadable({
        loader: function () { return import('../components/data/InsertLocationData'); },
        loading: NoLoading,
    }),
    DelayedButton: Loadable({
        loader: function () { return import('../components/buttons/DelayedButton'); },
        loading: NoLoading,
    }),
    LineDivider: Loadable({
        loader: function () { return import('../components/divider/LineDivider'); },
        loading: NoLoading,
    }),
    ErrorMessage: Loadable({
        loader: function () { return import('../components/error/ErrorMessage'); },
        loading: NoLoading,
    }),
    ExitIntent: Loadable({
        loader: function () { return import('../components/exitIntent/ExitIntentContainer'); },
        loading: Loading,
    }),
    ExitIntentMobile: Loadable({
        loader: function () { return import('../components/exitIntentMobile/ExitIntentMobileContainer'); },
        loading: Loading,
    }),
    ExternalDataAdapter: Loadable({
        loader: function () { return import('../components/externalDataAdapter/ExternalDataAdapter'); },
        loading: Loading,
    }),
    ExpandableImageBox: Loadable({
        loader: function () { return import('../components/imageBox/ExpandableImageBoxContainer'); },
        loading: NoLoading,
    }),
    Flexbox: Loadable({
        loader: function () { return import('../components/flexbox/FlexboxComponent'); },
        loading: NoLoading,
    }),
    FloatingActionButtonLauncherContainer: Loadable({
        loader: function () { return import('../components/launcher/FloatingActionButtonLauncherContainer'); },
        loading: NoLoading,
    }),
    Footer: Loadable({
        loader: function () { return import('../components/footer/ConversionalFooter'); },
        loading: Loading,
    }),
    Form: Loadable({
        loader: function () { return import('../components/form/FormContainer'); },
        loading: Loading,
    }),
    FormFieldTooltipContent: Loadable({
        loader: function () { return import('../components/form/fields/FormFieldTooltipContent'); },
        loading: Loading,
    }),
    FormWrapper: Loadable({
        loader: function () { return import('../components/form/wrappers'); },
        loading: Loading,
    }),
    Grid: Loadable({
        loader: function () { return import('../components/grid/GridContainer'); },
        loading: Loading,
    }),
    Handwriting: Loadable({
        loader: function () { return import('../components/handwriting/HandwritingComponent'); },
        loading: Loading,
    }),
    Header: Loadable({
        loader: function () { return import('../components/header/ConversionalHeader'); },
        loading: Loading,
    }),
    Icon: Loadable({
        loader: function () { return import('../components/icons/IconComponent'); },
        loading: NoLoading,
    }),
    IconButton: Loadable({
        loader: function () { return import('../components/buttons/IconButtonContainer'); },
        loading: NoLoading,
    }),
    IconGrid: Loadable({
        loader: function () { return import('../components/grid/IconGridContainer'); },
        loading: NoLoading,
    }),
    'Integrations.Landbot': Loadable({
        loader: function () { return import('../integrations/landbot/index'); },
        loading: Loading,
    }),
    InteractiveGrid: Loadable({
        loader: function () { return import('../components/interactiveGrid/InteractiveGridContainer'); },
        loading: NoLoading,
    }),
    InteractiveGridElements: Loadable({
        loader: function () { return import('../components/interactiveGrid/InteractiveGridElementsContainer'); },
        loading: NoLoading,
    }),
    InteractiveGridOverlay: Loadable({
        loader: function () { return import('../components/interactiveGrid/InteractiveGridOverlayContainer'); },
        loading: NoLoading,
    }),
    Intro: Loadable({
        loader: function () { return import('../components/intro/IntroComponent'); },
        loading: Loading,
    }),
    InternalExitIntent: Loadable({
        loader: function () { return import('../components/exitIntent/InternalExitIntent'); },
        loading: Loading,
    }),
    List: Loadable({
        loader: function () { return import('../components/list/ListComponent'); },
        loading: NoLoading,
    }),
    Loading: Loadable({
        loader: function () { return import('../components/loading/Loading'); },
        loading: NoLoading,
    }),
    Markdown: Loadable({
        loader: function () { return import('../components/markDown/MarkDownComponent'); },
        loading: NoLoading,
    }),
    ModalButton: Loadable({
        loader: function () { return import('../components/modalButton/ModalButtonContainer'); },
        loading: NoLoading,
    }),
    MoodboardSelect: Loadable({
        loader: function () { return import('../components/moodboard/MoodboardSelectContainer'); },
        loading: Loading,
    }),
    NavigationBar: Loadable({
        loader: function () { return import('../components/navigation/NavigationBar'); },
        loading: NoLoading,
    }),
    OpenResult: Loadable({
        loader: function () { return import('../components/OpenResult'); },
        loading: NoLoading,
    }),
    PersonalDataForm: Loadable({
        loader: function () { return import('../components/form/generic/PersonalDataForm'); },
        loading: NoLoading,
    }),
    PlainComponent: Loadable({
        loader: function () { return import('../components/plain/PlainComponent'); },
        loading: NoLoading,
    }),
    PreloadLocations: Loadable({
        loader: function () { return import('../components/preloadLocations/PreloadLocationsContainer'); },
        loading: NoLoading,
    }),
    Process: Loadable({
        loader: function () {
            return process.env.REACT_APP_JOURNEY_ENV === 'development'
                ? import('../components/process/ProcessContainerHotReloadAdapter')
                : import('../components/process/ProcessContainer');
        },
        loading: NoLoading,
    }),
    ProductView: Loadable({
        loader: function () { return import('../components/productView/ProductView'); },
        loading: NoLoading,
    }),
    'Process.DataAdapter': Loadable({
        loader: function () { return import('../components/process/ProcessDataAdapter'); },
        loading: NoLoading,
    }),
    Question: Loadable({
        loader: function () { return import('../components/question/QuestionContainer'); },
        loading: NoLoading,
    }),
    'Question.ClosureForm': Loadable({
        loader: function () { return import('../components/question/ClosureForm'); },
        loading: NoLoading,
    }),
    'Question.MultiImageSelect': Loadable({
        loader: function () { return import('../components/question/MultiImageSelect'); },
        loading: NoLoading,
    }),
    'Question.SingleImageSelectMultiSteps': QuestionSingleImageSelectMultiSteps,
    'Question.SingleImageSelect': QuestionSingleImageSelect,
    'Question.Switch': Loadable({
        loader: function () { return import('../components/question/Switch'); },
        loading: NoLoading,
    }),
    'Question.UploadWithAppointmentInformation': Loadable({
        loader: function () { return import('../components/question/upload/UploadWithAppointmentInformation'); },
        loading: NoLoading,
    }),
    'Question.SuccessScreen': Loadable({
        loader: function () { return import('../components/question/success/Success'); },
        loading: NoLoading,
    }),
    'Question.SliderQuestion': Loadable({
        loader: function () { return import('../components/form/widgets/SliderQuestion'); },
        loading: NoLoading,
    }),
    'Question.AppointmentConfirmation': Loadable({
        loader: function () { return import('../components/question/AppointmentConfirmation'); },
        loading: NoLoading,
    }),
    ResponsiveImage: Loadable({
        loader: function () { return import('../components/responsiveImage/ResponsiveImageComponent'); },
        loading: NoLoading,
    }),
    ResultBox: Loadable({
        loader: function () { return import('../components/result/ResultBox'); },
        loading: NoLoading,
    }),
    ResultCallToAction: Loadable({
        loader: function () { return import('../components/result/ResultCallToAction'); },
        loading: NoLoading,
    }),
    ScrollIndicator: Loadable({
        loader: function () { return import('../components/scrollIndicator/ScrollIndicatorComponent'); },
        loading: Loading,
    }),
    ScrollFadeout: Loadable({
        loader: function () { return import('../components/scrollFadeout/ScrollFadeoutContainer'); },
        loading: Loading,
    }),
    ScrollableTabs: Loadable({
        loader: function () { return import('../components/tabs/ScrollableTabs'); },
        loading: Loading,
    }),
    Section: Loadable({
        loader: function () { return import('../components/section/SectionContainer'); },
        loading: NoLoading,
    }),
    Snackbar: Loadable({
        loader: function () { return import('../components/snackbar/SnackbarContainer'); },
        loading: NoLoading,
    }),
    StandardImageSelectExitIntent: Loadable({
        loader: function () { return import('../components/exitIntent/layouts/StandardImageSelectExitIntent'); },
        loading: NoLoading,
    }),
    StudioColumn: Loadable({
        loader: function () { return import('../components/studio/StudioColumn'); },
        loading: NoLoading,
    }),
    Styling: Loadable({
        loader: function () { return import('../components/styling/StylingComponent'); },
        loading: NoLoading,
    }),
    StyleTracker: Loadable({
        loader: function () { return import('../components/styleTracker/StyleTrackerContainer'); },
        loading: NoLoading,
    }),
    Subsection: Loadable({
        loader: function () { return import('../components/section/SubsectionContainer'); },
        loading: NoLoading,
    }),
    FloatingActionButton: Loadable({
        loader: function () { return import('../components/floatingActionButton/FloatingActionButton'); },
        loading: NoLoading,
    }),
    TextBox: Loadable({
        loader: function () { return import('../components/textBox/TextBox'); },
        loading: NoLoading,
    }),
    TextArea: Loadable({
        loader: function () { return import('../components/result/TextArea'); },
        loading: NoLoading,
    }),
    Timeslot: Loadable({
        loader: function () { return import('../components/timeslot/Timeslot'); },
        loading: NoLoading,
    }),
    Typography: Loadable({
        loader: function () { return import('../components/typography/Typography'); },
        loading: NoLoading,
    }),
    VendorLocation: Loadable({
        loader: function () { return import('../components/vendorLocation/VendorLocation'); },
        loading: NoLoading,
    }),
    AppointmentLocationDateTime: Loadable({
        loader: function () { return import('../components/appointmentBooking'); },
        loading: NoLoading,
    }),
    Table: Loadable({
        loader: function () { return import('../components/table/Table'); },
        loading: NoLoading,
    }),
    Tips: Loadable({
        loader: function () { return import('../components/tips/Tips'); },
        loading: NoLoading,
    }),
    TrustBoost: Loadable({
        loader: function () { return import('../components/header/TrustBoost'); },
        loading: NoLoading,
    }),
    'Trust.ProvenExpert': Loadable({
        loader: function () { return import('../components/trust/ProvenExpert'); },
        loading: NoLoading,
    }),
    TrustPulse: Loadable({
        loader: function () { return import('../components/trustPulse/TrustPulseContainer'); },
        loading: NoLoading,
    }),
    UserFeedback: Loadable({
        loader: function () { return import('../components/userFeedback/UserFeedbackContainer'); },
        loading: NoLoading,
    }),
    Switch: Loadable({
        loader: function () { return import('../components/switch/SwitchComponent'); },
        loading: NoLoading,
    }),
    Swiper: Loadable({
        loader: function () { return import('../components/swiper/SwiperContainer'); },
        loading: NoLoading,
    }),
    CustomStepper: Loadable({
        loader: function () { return import('../components/stepper/CustomStepper'); },
        loading: NoLoading,
    }),
    ConfirmationScreen: Loadable({
        loader: function () { return import('../components/confirmation/ConfirmationScreen'); },
        loading: NoLoading,
    }),
    AvivaCustomResult: Loadable({
        loader: function () { return import('../components/aviva/CustomResult'); },
        loading: NoLoading,
    }),
    InhoferCustomResult: Loadable({
        loader: function () { return import('../components/inhofer/CustomResult'); },
        loading: NoLoading,
    }),
    FormConsulter: Loadable({
        loader: function () { return import('../components/FormConsulter/Consulter'); },
        loading: NoLoading,
    }),
};
export default componentMap;
